// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 30) return "static/chunks/30-99c7a7133e50c364.js";
	if (chunkId === 836) return "static/chunks/836-c0f37500a5242931.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"87a6db885125b558","40":"9364aa63b5d97a35","99":"85e5e1933382a7a4","351":"e67403d16ba9c50c","515":"240cec37b42e4a9c","659":"1ca4aaf44a85bcd7","777":"dcdf79c5cdc62826","809":"2280097ec03d36d3"}[chunkId] + ".js";
};